import React, { useState, useEffect, useContext } from 'react';
import { context } from '../../../context';
import { DropDown } from '../../atoms';
import { useHandleSortBy } from '../../../hooks';
import { getLabel } from '../../../helpers';
import { Select, Option } from './Styled';

const SelectSort = (props: any) => {
  const { sorts, dispatchMetrics } = props;
  const { queryParam } = useContext<any>(context);
  const [defaultSelected] = sorts;
  const [label, setLabel] = useState(defaultSelected.label);
  const { handleSortBy } = useHandleSortBy();

  const onChange = ({ target }: { target: { name: string } }) => {
    const { name } = target;
    const { value } = sorts.find((arr: { label: string }) => arr.label === name);

    handleSortBy({ sortBy: value });

    dispatchMetrics('event:track', {
      category: 'avaliacao-pdp',
      action: 'avaliacoes-ordenacao',
      label: target.name,
    });
  };

  useEffect(() => {
    setLabel(getLabel(queryParam.sortBy));
  }, [queryParam]);

  const renderCheckbox = sorts?.map((sort: any) => (
    <Option key={sort.value}>
      <input type="checkbox" id={sort.label} name={sort.label} onChange={onChange} checked={label === sort.label} />
      <label htmlFor={sort.label}>{sort.label}</label>
    </Option>
  ));

  return (
    <>
      <DropDown label={label} oneClick>
        <Select>{renderCheckbox}</Select>
      </DropDown>
    </>
  );
};

SelectSort.defaultProps = {
  sorts: [
    {
      label: 'mais relevantes',
      value: ['scoreDesc', 'createdAtDesc'],
    },
    {
      label: 'mais recentes',
      value: ['createdAtDesc'],
    },
    {
      label: 'mais antigas',
      value: ['createdAtAsc'],
    },
    {
      label: 'mais positivas',
      value: ['ratingDesc', 'scoreDesc', 'createdAtDesc'],
    },
    {
      label: 'mais negativas',
      value: ['ratingAsc', 'scoreDesc', 'createdAtDesc'],
    },
  ],
};

export default SelectSort;
export { SelectSort };
